export default __webpack_public_path__ + "static/media/export-square.40265d74.svg";